<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="视频标题">
                  <el-input style="width: 177px" v-model="queryForm.videoTitle"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 177px" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                               :value="queryForm.userId" :limit='1'
                               size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code"
                               :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="上传状态">
<!--                  <el-input style="width: 177px" v-model="queryForm.status"></el-input>-->
                  <el-select v-model="queryForm.status" placeholder="请选择" clearable>
                      <el-option
                          label="上传中"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="上传成功"
                          :value="2"
                      ></el-option>
                      <el-option
                          label="上传失败"
                          :value="3"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoHotcodeMaterialList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addVideoHotcodeMaterial"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editVideoHotcodeMaterial(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteVideoHotcodeMaterial(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportVideoHotcodeMaterialList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshVideoHotcodeMaterialList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoHotcodeMaterialList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoTitle"
        label="视频标题"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoPic"
        label="视频图片"
        min-width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.videoPic">
                  <el-image
                      @click='updateSrcList(scope.row.videoPic)'
                      style="width: 60px; height: 60px"
                      :src="scope.row.videoPic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSrc"
        label="视频地址"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSize"
        label="视频大小"
        min-width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.videoSize">
                  {{ scope.row.videoSize + "M" }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoDuration"
        label="视频时长"
        min-width="180"
      >
            <template slot-scope='scope'>
                <div v-if="scope.row.videoDuration">
                    {{ scope.row.videoDuration + "s" }}
                </div>
                <div v-else>--</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                  <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                  <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                  <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="上传状态"
        min-width="180"
      >
          <template slot-scope='scope'>
              {{scope.row.status == 1 ? '上传中' : (scope.row.status == 2 ? '上传成功' : '上传失败')}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="viewVideo(scop.row.videoSrc)" v-if="scop.row.status == 2">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">播放</span>
              </div>
            <div @click="checkVideoHotcodeMaterial(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editVideoHotcodeMaterial(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteVideoHotcodeMaterial(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoHotcodeMaterialStates[videoHotcodeMaterialState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoHotcodeMaterial"
          ref="videoHotcodeMaterialForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="视频标题"
            prop="videoTitle"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMaterial.videoTitle"
              :disabled="videoHotcodeMaterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频图片"
            prop="videoPic"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMaterial.videoPic"
              :disabled="videoHotcodeMaterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频地址"
            prop="videoSrc"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMaterial.videoSrc"
              :disabled="videoHotcodeMaterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频大小"
            prop="videoSize"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMaterial.videoSize"
              :disabled="videoHotcodeMaterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="videoHotcodeMaterial.userId"-->
<!--              :disabled="videoHotcodeMaterialState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                           :value="videoHotcodeMaterial.userId" :limit='1' :disabled="videoHotcodeMaterialState == 'check'"
                           size='small' placeholder='请选择用户' @getValue="getValueUser" :columns="USER_code"
                           :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
            label="上传状态"
            prop="status"
          >
                <el-select
                  v-model="videoHotcodeMaterial.status"
                  placeholder="请选择"
                  style="width: 177px"
                  :disabled="videoHotcodeMaterialState == 'check'"
                >
                    <el-option
                        label="上传中"
                        :value="1"
                    ></el-option>
                    <el-option
                        label="上传成功"
                        :value="2"
                    ></el-option>
                    <el-option
                        label="上传失败"
                        :value="3"
                    ></el-option>
                </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoHotcodeMaterialState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import GridSelectU from '@/components/gridselect';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoHotcodeMaterialList();
                    this.getVideoHotcodeMaterialList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoHotcodeMaterialList();
                    this.getVideoHotcodeMaterialList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     videoTitle: '', //视频标题
                     videoPic: '', //视频图片
                     videoSrc: '', //视频地址
                     videoSize: '', //视频大小
                     userId: '', //用户ID
                     status: '',
                },
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoHotcodeMaterialState: 'add',
                videoHotcodeMaterialStates: {
                    add: '新建素材',
                    check: '查看素材',
                    edit: '修改素材'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                videoHotcodeMaterialList: [],
                videoHotcodeMaterial: {
                    id: '', //ID
                    videoTitle: '', //视频标题
                    videoPic: '', //视频图片
                    videoSrc: '', //视频地址
                    videoSize: '', //视频大小
                    userId: '', //用户ID
                    status: '',
                },
                btnLoading: false,

                rules: {
                    videoTitle: [{ required: true, message: '视频标题不能为空', trigger: 'blur' }],
                    videoPic: [{ required: true, message: '视频图片不能为空', trigger: 'blur' }],
                    videoSrc: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    videoSize: [{ required: true, message: '视频大小不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getVideoHotcodeMaterialList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            getValueUser(value){
                this.videoHotcodeMaterial.userId = value;
            },
            viewVideo(url){
                window.open(url)
            },
            updateSrcList(url){
                this.srcList[0] = url
            },
            resetVideoHotcodeMaterialList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoHotcodeMaterialList = [];
            },
            resetDialog() {
                this.videoHotcodeMaterialState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      videoTitle: '', //视频标题
                      videoPic: '', //视频图片
                      videoSrc: '', //视频地址
                      videoSize: '', //视频大小
                      userId: '', //用户ID
                      status: '',
                };
                this.getVideoHotcodeMaterialList();
            },
            closeDialog() {
                this.showDialog = false
                this.videoHotcodeMaterial = {
                      id: '', //ID
                      videoTitle: '', //视频标题
                      videoPic: '', //视频图片
                      videoSrc: '', //视频地址
                      videoSize: '', //视频大小
                      userId: '', //用户ID
                };
            },
            submitForm() {
                if (this.videoHotcodeMaterialState == 'add') {
                    this.$refs.videoHotcodeMaterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodematerial/add`,{ ...this.videoHotcodeMaterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoHotcodeMaterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.videoHotcodeMaterialState == 'edit') {
                    this.$refs.videoHotcodeMaterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodematerial/edit`,{ ...this.videoHotcodeMaterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoHotcodeMaterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addVideoHotcodeMaterial() {
                this.showDialog = true;
                this.videoHotcodeMaterialState = 'add';
            },
            checkVideoHotcodeMaterial(videoHotcodeMaterialId) {
                console.log(videoHotcodeMaterialId);
                this.currentVideoHotcodeMaterialId = videoHotcodeMaterialId;

                this.getVideoHotcodeMaterialById();
                this.showDialog = true;
                this.videoHotcodeMaterialState = 'check';
            },
            editVideoHotcodeMaterial(videoHotcodeMaterialId) {
                console.log('videoHotcodeMaterial', videoHotcodeMaterialId);
                if (videoHotcodeMaterialId) {
                    this.currentVideoHotcodeMaterialId = videoHotcodeMaterialId;
                    this.getVideoHotcodeMaterialById();
                } else {
                    this.videoHotcodeMaterial = { ...this.videoHotcodeMaterial, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoHotcodeMaterialState = 'edit';
            },
            deleteVideoHotcodeMaterial(videoHotcodeMaterialId) {
                let ids = '';
                if (videoHotcodeMaterialId) {
                    ids = videoHotcodeMaterialId;
                } else {
                    ids = this.multipleSelection.map((videoHotcodeMaterial) => videoHotcodeMaterial.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/hotcodematerial/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoHotcodeMaterialList();
                                this.getVideoHotcodeMaterialList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoHotcodeMaterialList() {
                this.resetVideoHotcodeMaterialList();
                this.getVideoHotcodeMaterialList();
            },
            getVideoHotcodeMaterialList(query = {}) {
                this.loading = true;
                get(`/video/hotcodematerial/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.videoHotcodeMaterialList = [];
                        for (let item of res.page.list) {
                            item.videoSize = (item.videoSize / 1024 / 1024).toFixed(2)
                            this.videoHotcodeMaterialList.push(item)
                        }
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getVideoHotcodeMaterialById() {
                get(`/video/hotcodematerial/get`,{ id: this.currentVideoHotcodeMaterialId }).then((res) =>{
                    if(res.success){
                      this.videoHotcodeMaterial = { ...this.videoHotcodeMaterial, ...res.videoHotcodeMaterial };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoHotcodeMaterialList() {
                //this.btnLoading = true;
                exprotExcel(`/video/hotcodematerial/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/hotcodematerial/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/hotcodematerial/importData`,formData);
              this.refreshVideoHotcodeMaterialList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoHotcodeMaterialList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoHotcodeMaterialList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>